import React from 'react';
import {Label, Tooltip} from '@lightricks/react-design-system';
import getFollowersCountString from '@/utils/getFollowersCountString';
import type {OffPlatformCreatorSnapshotIdentity} from '@/api/fetchers/crm/offPlatformCreators';
import {formatStatValue} from '@/views/campaigns/stats/utils';
import platformStyles from '@/components/creator-profile/components/platform-followers/PlatformFollowers.module.scss';
import SocialNetworkIcon from '@/components/social-network-icon';

export default function OffPlatformPlatformFollowers({
  identities,
}: {
  identities: OffPlatformCreatorSnapshotIdentity[];
}) {
  const withFollowers = identities.filter(
    (identity) => identity.followerCount != null
  );
  if (withFollowers.length === 0) {
    return null;
  }

  return (
    <div className={platformStyles.platformFollowers}>
      {withFollowers.map((identity) => {
        const er =
          identity.engagementRate != null
            ? formatStatValue(identity.engagementRate, 'percentage')
            : null;
        const content = (
          <>
            <SocialNetworkIcon
              name={identity.provider}
              width={20}
              height={20}
            />
            <Label size="md">
              {getFollowersCountString(identity.followerCount ?? undefined)}
            </Label>
          </>
        );
        return (
          <Tooltip
            key={`${identity.provider}-${identity.handle}`}
            arrow
            type="light"
            placement="bottom"
            disableInteractive
            title={[
              `${getFollowersCountString(identity.followerCount ?? undefined)} followers`,
              er ? `Engagement rate: ${er}` : null,
            ]
              .filter(Boolean)
              .join('. ')}
          >
            {identity.profileUrl ? (
              <a
                className={platformStyles.platformItem}
                href={identity.profileUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {content}
              </a>
            ) : (
              <div className={platformStyles.platformItem}>{content}</div>
            )}
          </Tooltip>
        );
      })}
    </div>
  );
}
